import React from 'react';

import { useTranslation } from 'react-i18next';

import { PrimaryButton, NakedButton } from 'components/UI';

import StyledModal from '../StyledModal/StyledModal';
import { TitleContainer, TextContainer, StyledWarningOutlined, IconContainer } from './styles';

interface PropsConfirmModal {
  customElement?: React.ReactNode;
  customTitle?: string;
  customTitleKey?: string;
  icon?: JSX.Element | JSX.Element[] | null;
  onCancel?: () => void;
  onOk: () => void;
  open: boolean;
  showOnlyCloseBtn?: boolean;
  text?: string;
  textKey?: string;
}

const ConfirmModal: React.FC<PropsConfirmModal> = ({
  text,
  textKey,
  customTitle,
  customTitleKey,
  icon = <StyledWarningOutlined />,
  open,
  onCancel,
  onOk,
  customElement,
  showOnlyCloseBtn = false,
}) => {
  const { t } = useTranslation('translation');

  return (
    <div>
      <StyledModal
        centered
        open={open}
        onOk={onOk}
        onCancel={onCancel}
        footer={
          showOnlyCloseBtn ? (
            <PrimaryButton onClick={onOk} key="confirm" text={t('common.close')} />
          ) : (
            [
              <NakedButton
                key="cancel"
                onClick={onCancel}
                style={{ border: 'none', marginRight: 15, background: 'transparent', color: '#ffffff' }}
              >
                {t('common.cancel')}
              </NakedButton>,
              <PrimaryButton onClick={onOk} key="confirm" text={t('common.confirm')} />,
            ]
          )
        }
        zIndex={2000}
      >
        {icon && <IconContainer>{icon}</IconContainer>}
        <TitleContainer>{customTitleKey ? t(customTitleKey) : customTitle}</TitleContainer>
        <TextContainer>{textKey ? t(textKey) : text}</TextContainer>
        {customElement && customElement}
      </StyledModal>
    </div>
  );
};

export default ConfirmModal;
